import * as SC from './style';
import AlignedInfoBox from './AlignedInfoBox';
import { IAlignedInfo } from './types';

const AlignedInfo = ({ data }: IAlignedInfo) => {
  return (
    <>
      <SC.BackgroundContainer />
      {data?.map((item, index) => (
        <SC.AIContainer key={index}>
          <SC.AIInner>
            <AlignedInfoBox direction={!!(index % 2)} {...item} />
          </SC.AIInner>
        </SC.AIContainer>
      ))}
    </>
  );
};

export default AlignedInfo;
